export default __webpack_public_path__ + "static/media/marker-sky-red-yellow.50e27ed6.png";